<template>
    <div>
      <!-- 展示各个工厂的机台，以获取配对码 -->
        <!-- 面包屑导航区域 -->
        <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>机台列表</el-breadcrumb-item>
        </el-breadcrumb> -->
        <!-- 卡片视图区域 -->
        <el-card >
            <!-- 搜索与添加区域 -->
        <el-row :gutter=20>
            <el-col  :span="7">
                <el-select v-model="selectValue" placeholder="请选择" @change="selectChange">
                  <el-option
                    v-for="(item,index) in Factory"
                    :key="index"
                    :label="item.label"
                    :value="item.label">
                  </el-option>
                </el-select>
            </el-col>

            <el-col :span="4">
                <el-button type="primary" @click="canAddMachine()" size="mini">添加机台</el-button>
            </el-col>
        </el-row>
        <!-- 用户列表区 -->
        <el-table :header-cell-style="{'text-align':'center'}"
                  :cell-style="{'text-align':'center','padding':'0px'}"
                  :data="machineList" border stripe>
            <el-table-column type="index"></el-table-column>
            <el-table-column label="机台编号 " prop="machineNumber"></el-table-column>
            <el-table-column label="配对状态" prop="pairState">
              <template slot-scope="scope">
                <el-tag type="danger" v-if="scope.row.pairState === 0">未配对</el-tag>
                <el-tag type="success" v-else>已配对</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="配对码" prop="pairCode">
            </el-table-column>

            <el-table-column label="所在车间" prop="workshop"></el-table-column>
            <el-table-column label="轴长(米) " prop="warpKnittingMachineAxialLength"></el-table-column>
            <el-table-column label="面梳(个)" prop="warpKnittingMachineMaxComb"></el-table-column>
            
            <el-table-column label="机台类型 " prop="machineType"></el-table-column>

            <el-table-column  label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="openNoticeDialog(scope.row.machineId,scope.$index,scope.row.pairState)" size="mini" v-show="scope.row.pairState == 0">生成配对码</el-button>
                <el-button type="text" @click="unPair(scope.row)" size="mini" v-show="scope.row.pairState !== 0">解除配对</el-button>
                <!-- <el-tooltip  effect="dark" content="模拟2.0" placement="top" :enterable="false">
                  <el-button type="primary" icon="el-icon-notebook-1" size="mini" @click="goToIpcPage(scope.row.machineId)"></el-button>
                </el-tooltip> -->

                <el-button type="text" size="mini" @click="$refs.machineEdit.show(
                scope.row.factoryId, // 工厂项目
                scope.row.id,
                scope.row.machineId,

                scope.row.machineNumber,// 机台编号
                scope.row.workshop,// 所属车间
                scope.row.warpKnittingMachineAxialLength,// 轴长
                scope.row.warpKnittingMachineMaxComb, // 面梳
                scope.row.machineType, // 机台类型
                )">修改</el-button>
                <el-button type="text" size="mini" >删除</el-button>
              </template>
            </el-table-column>
        </el-table>
        <!-- 分页区域 -->
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[3,5,10,15]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
        </el-card>

        <!-- 提示对话框 -->
        <el-dialog
          title="提示"
          :visible.sync="noticeVisible"
          width="30%">
          <span>生成配对码会使机台变为未配对状态，是否生成?</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="noticeVisible = false">取 消</el-button>
            <el-button type="primary" @click="resetPairCode">确 定</el-button>
          </span>
        </el-dialog>

        <!-- 添加机台弹框 -->
        <machine-add ref="machineAdd" @update="handleCurrentChange(queryInfo.pagenum)"/>
        <!-- 修改机台弹框 -->
        <machine-edit ref="machineEdit" @update="handleCurrentChange(queryInfo.pagenum)"/>

        <!-- 未选择工厂的错误提示框 -->
        <el-dialog
          title="提示"
          :visible.sync="errorDialogVisible"
          width="30%">
          <span>请先选择工厂</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="errorDialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>
    </div>
</template>
<script>
import { MachineAdd, MachineEdit } from './components'
import * as api from '@/api/platform/machine/list'
export default {
  components: {
    MachineAdd, MachineEdit
  },
  data () {
    return {
      machineId: '',
      selectIndex: '', // 选中的 工厂index
      noticeVisible: false,
      Factory: [],
      selectValue: '', // 选中的 工厂名称
      factoryId: '', // 选中的 工厂id
      machineList: [], // 机台列表

      // 获取用户列表的请求参数
      queryInfo: {
        query: '',
        // 当前的页数
        pagenum: 1,
        // 当前每页显示的数量
        pagesize: 10
      },
      total: 0,
      // 添加机台 sta
      errorDialogVisible: false // 未选择工厂的错误提示框
      // 添加机台 end
    }
  },
  created () {
    this.getFactory()
    this.selectValue = window.sessionStorage.getItem('queryFactoryName')
    if (this.selectValue !== '') {
      this.selectChange(this.selectValue)
    }
  },
    // F5刷新时候，beforeMount()会被调用
    beforeMount () {
        // console.log('测试F5刷新')

        // hongmj: 案1: 把当前页面号 缓存到store, F5刷新时候 能回到当前页面。
        // const pageInfo = this.$store.state.commonSavePage.pageInfo
        // let savedPage = 1 // 默认值为第1页
        // pageInfo.forEach((item) => {
        //     console.log('item.module=', item.module)
        //     console.log('item.page=', item.page)
        //     if (item.module === 'platform_machineList') { // 找到匹配
        //         savedPage = item.page // 直接更新page.
        //     }
        // })

        // console.log('this.selectValue=', this.selectValue)
        if (this.selectValue !== '') { // 已经选择工厂 才执行
            // hongmj: 案2: 利用sessionStorage 保存当前页面号，F5刷新时候 能回到当前页面。
            const savedPage = window.sessionStorage.getItem('platform_MachineList')
            // console.log('savedPage=', savedPage)

            // 去刷新页面
            if (savedPage !== null) {
                this.queryInfo.pagenum = savedPage
                // this.selectChange(this.selectValue) 会产生2次请求，禁止写。
            }
        }
    },
  methods: {
    // 路由至模拟器界面，现不支持
    goToIpcPage(machineId) {
      this.$router.push({
        path: `/platform/machines/IPCSimulation/${machineId}`
      })
    },
    // 获取工厂名列表
    getFactory () {
      api.getFactory().then(res => {
        res.data.forEach(item => {
          this.Factory.push({ label: item })
        })
      })
    },
    // 选择器发生改变
    selectChange (val) {
      window.sessionStorage.setItem('queryFactoryName', val)
      this.queryInfo.query = val
      this.getMachineList()
    },
    // 根据选择的工厂，获取机台列表
    getMachineList () {
      const params = this.queryInfo
      api.getMachineList(params).then(res => {
        this.$message.success('获取机台成功！')
        this.machineList = res.data.list
        this.factoryId = res.data.id // 选中的 工厂id
        this.total = res.data.total
      })
    },
    // 监听 pagesize 改变的事件
    handleSizeChange (newSize) {
    //   console.log(newSize)
      this.queryInfo.pagesize = newSize
      this.selectChange(this.selectValue)
    },
    // 监听 页码值 改变的事件
    handleCurrentChange (newpage) {
    //   console.log(newpage)
      this.queryInfo.pagenum = newpage
      this.selectChange(this.selectValue)

      // hongmj: 案1: 把当前页面号 缓存到store, F5刷新时候 能回到当前页面。
      // const pageCache = {
      //   module: 'platform_machineList',
      //   page: newpage
      // }
      // this.$store.commit('commonSavePage/SAVE_PAGE', pageCache)

      // hongmj: 案2: 利用sessionStorage 保存当前页面号，F5刷新时候 能回到当前页面。
      window.sessionStorage.setItem('platform_MachineList', newpage)
    },
    // 若是已配对的机台获取配对码则有提示
    openNoticeDialog (machineId, index, pairState) {
      this.machineId = machineId
      this.selectIndex = index
      if (pairState === 1) {
        this.noticeVisible = true
      } else {
        this.generatePairCode()
      }
    },
    // 生成机台的配对码
    generatePairCode() {
      api.generatePairCode(this.machineId).then(res => {
        this.$message.success('获取配对码成功！')
        this.machineList[this.selectIndex].pairCode = res.data.pairCode
      })
    },
    // 重新获取配对码
    resetPairCode() {
      this.generatePairCode()
      this.noticeVisible = false
    },
    // 解除配对
    unPair(row) {
      this.$confirm('是否解除该机台的配对？', '解除配对', {
        type: 'error'
      }).then(res => {
        const data = {
            time: new Date().getTime(),
            uuid: row.ipcId,
            data: {
              factoryId: row.factoryId,
              machineId: row.machineId
            }
          }
        api.unPair(data).then(res => {
          this.$Message.success('解除配对成功!')
          this.getMachineList()
        })
      })
    },

    // 检查能否弹出 “添加机台” 对话框。
    canAddMachine() {
        // console.log('selectValue=', this.selectValue)
        if (this.selectValue === '') { // 弹出错误提示框
            this.errorDialogVisible = true
        } else { // 弹出 “添加机台” 对话框
            this.$refs.machineAdd.show(this.factoryId)
        }
    }

  }
}
</script>

<style lang="less" scoped>
.el-table {
    margin-top: 15px;
    font-size: 12px;
}

.el-pagination {
    margin-top: 15px;
}

.el-cascader-panel {
    height: 200px;
}
</style>
